<template>
  <yd-layout>
    <router-view></router-view>
  </yd-layout>
</template>

<script type="text/ecmascript-6">
  export default {
    name: 'App'
  }
</script>

<style type="text/css" scoped>


</style>



// WEBPACK FOOTER //
// src/App.vue